import { RegistryItem } from "@schemas/agreementconditions/schema";
import { AgreementConditionType } from "__generated__/graphql";


export const ShipSchema: RegistryItem = {
	[AgreementConditionType.Ship]: {
		fields: {
			"conditions.ship": {
				path: "ship",
				rules: {
					required: true,
				},
			},
		},
		toInput: (form) => ({
			ship: form.ship?.id,
		}),
		toForm: (condition) => ({
			ship: condition.ship ?? undefined,
		}),
	},
};
